// ABOUTME: Shared S22 responsive-scale calc for Crossing step geometry -- one clamp formula so
// ABOUTME: every wave-3 step (breathe, weather, entry) rides the same scale instead of reinventing it.
import { useEffect, useState } from 'react';
import { useTheme, useMediaQuery } from '@mui/material';

const MIN_SCALE = 0.3;
const MAX_SCALE = 1;
const VIEWPORT_MARGIN = 48;
const FRAME_MARGIN = 28;

export function computeFrameScale(viewportWidth: number, frameWidth: number): number {
  const ratio = (viewportWidth - VIEWPORT_MARGIN) / (frameWidth + FRAME_MARGIN);
  return Math.min(MAX_SCALE, Math.max(MIN_SCALE, ratio));
}

export interface FrameScale {
  frameSc: number;
  mob: boolean;
}

export function useFrameScale(frameWidth: number): FrameScale {
  const theme = useTheme();
  const mob = useMediaQuery(theme.breakpoints.down('sm'));
  const [viewportWidth, setViewportWidth] = useState(() => (typeof window !== 'undefined' ? window.innerWidth : frameWidth));

  useEffect(() => {
    const handler = () => setViewportWidth(window.innerWidth);
    window.addEventListener('resize', handler);
    return () => window.removeEventListener('resize', handler);
  }, []);

  return { frameSc: computeFrameScale(viewportWidth, frameWidth), mob };
}
